<template>
    <div>

            <div class="docs-search" v-if="danger === 'true'">
                <form id="serial-search" class="docs-search-form">
                    <input type="search" v-model="userRequest" :placeholder="placeholder" class="docs-search__input">
                    <button disabled="disabled">Найти</button>
                </form>
                <p class="text--danger">Извините, в данный момент сервис недоступен.</p>
                <p class="text--big">Для получения технической документации заполните форму на сайте или отправьте запрос по электронной почте на адрес <a href="mailto:info@elmeh.ru">info@elmeh.ru</a>.</p>
                <p class="text--big">Наши специалисты свяжутся с вами и предоставят всю необходимую информацию.</p>
            </div>
        
            <div class="docs-search" v-else>
            <form id="serial-search" @submit.prevent="userRequestSearch" class="docs-search-form">
                <input type="search" v-model="userRequest" :placeholder="placeholder" class="docs-search__input">
                <button type="submit">Найти</button>
            </form>
            <p class="docs-search__small" v-html="smallText">

            </p>
        </div>
        
        

        <div class="row">
            
            <div class="column">
                <!--
                    <div class="docs-error" v-if="listResults || serialResults === '\r\n'">
                    <Error />
                </div>

                <div class="docs-error" v-if="listResults || serialResults === ''">
                    <Error />
                </div>
                -->

                <div class="docs-error" v-if="listResults === '\r\n' && serialResults === '' ">
                    <Error />
                </div>

                                
                <div class="docs-results" v-for="item in listResults" :key="item.id" v-else>
                    <div class="docs-results__search" v-if="item.type === 'search'">
                       <SearchResults 
                            :name="item.name"
                            :cakt="item.cakt"
                            :link="item.link"
                       />
                    </div>
                    <div class="docs-results__download" v-else-if="item.type === 'download'">
                        <DownloadResults 
                            :fullname="item.fullname"
                            :cakt="item.cakt"
                            :link="item.link"
                            :type="item.type"
                        />
                    </div>
                </div>
                
                <div class="docs-results" v-for="item in serialResults" :key="item.id" >
                    <div class="docs-results__search" v-if="item.type === 'search'">
                       <SearchResults 
                            :name="item.name"
                            :cakt="item.cakt"
                            :link="item.link"
                       />
                    </div>
                    <div class="docs-results__download" v-else-if="item.type === 'download'">
                        <DownloadResults 
                            :fullname="item.fullname"
                            :cakt="item.cakt"
                            :link="item.link"
                            :type="item.type"
                        />
                    </div>
                </div>

                
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Error from '@/components/Errors/Error.vue'
import SearchResults from '@/components/Results/search-result.vue'
import DownloadResults from '@/components/Results/download-result.vue'
export default {
    name: 'SearchForm2',
    components: {
        Error, 
        SearchResults, DownloadResults
    },
    props: {
        placeholder: String,
        smallText: String,
        urlS: String,
        urlN: String,
        danger: String
    },
    data() {
        return {
            showUserRequest: true,
            userRequest: null,
            listResults: [],
            serialResults: []
        }
    },
    methods: {
        userRequestSearch() {
                axios
                    .all([
                        axios.get('https://elmeh.ru:10110/' + 'n=="' + this.userRequest + '"'),
                        axios.get('https://elmeh.ru:10110/' + 's=="' + this.userRequest + '"')
                    ])
                    .then(
                        axios.spread((listResponse, userResponse) => {
                            this.listResults = listResponse.data
                            this.serialResults = userResponse.data
                        })
                    )
                    .catch(error => {
                        console.log(error)
                    })
                    .then(
                        this.userRequest = null
                    )
        }
    }
    //watch: {
    //    userRequestSearch() {
    //        console.log('Нажалась кнопка Найти')
    //    }
    //}
}
</script>

<style lang="sass">
.docs-search-form button
    &:disabled
        border: 1px solid #01278621
        &:hover
            border: 1px solid #01278621
            background-color: #fff
            color: #5a72b0
            cursor: not-allowed
.text
    &--danger
        color: #d50000
        font-size: 16px
    &--big
        color: #000
        font-size: 15px
        width: 90%
.docs-search-form
    button
        &:hover
            background-color: #5a72b0
            color: #fff
</style>